module.exports = __webpack_public_path__ + "img/1-9.29b7d171.png";